import { apiClient } from '@/core/api/httpClient'

export default {
  loadDocs: async () => {
    return await apiClient.get('/api-docs')
  },
  loadDocsToken: async () => {
    return await apiClient.get(`/api-docs/${process.env.VUE_APP_DOCS_SECURE_KEY}`)
  },
}
